var map = {
	"./dc-arrow.jpg": 31,
	"./dc-batman.jpg": 32,
	"./dc-black.jpg": 33,
	"./dc-blue.jpg": 34,
	"./dc-flash.jpg": 35,
	"./dc-green.jpg": 36,
	"./dc-martian.jpg": 37,
	"./dc-robin.jpg": 38,
	"./dc-superman.jpg": 39,
	"./dc-wonder.jpg": 40,
	"./marvel-captain.jpg": 41,
	"./marvel-cyclops.jpg": 42,
	"./marvel-daredevil.jpg": 43,
	"./marvel-hawkeye.jpg": 44,
	"./marvel-hulk.jpg": 45,
	"./marvel-iron.jpg": 46,
	"./marvel-silver.jpg": 47,
	"./marvel-spider.jpg": 48,
	"./marvel-thor.jpg": 49,
	"./marvel-wolverine.jpg": 50
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;